import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { ArrowRight, Lock, Phone, Star, MessageCircle } from 'lucide-react';

const LoginForm = ({ companyInfo }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    if (result.success) { toast.success('Bienvenido!'); navigate('/'); }
    else { toast.error(result.error); }
    setLoading(false);
  };

  return (
    <div className="space-y-5">
      {/* Login Card */}
      <div className="bg-white/5 rounded-2xl border border-white/10 overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-5 py-4">
          <h2 className="text-lg font-bold flex items-center gap-2"><Lock className="h-5 w-5" /> Acceso al Sistema</h2>
          <p className="text-blue-200 text-sm">Panel de administracion</p>
        </div>
        <div className="p-5">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label className="text-xs font-bold text-white/60">Correo</Label>
              <Input data-testid="login-email" type="email" placeholder="correo@ejemplo.com"
                value={email} onChange={(e) => setEmail(e.target.value)} required
                className="h-12 text-base bg-white/10 border-white/20 text-white placeholder:text-white/30 mt-1" />
            </div>
            <div>
              <Label className="text-xs font-bold text-white/60">Contrasena</Label>
              <Input data-testid="login-password" type="password" placeholder="Tu contrasena"
                value={password} onChange={(e) => setPassword(e.target.value)} required
                className="h-12 text-base bg-white/10 border-white/20 text-white placeholder:text-white/30 mt-1" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full h-12 text-base font-bold bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 shadow-lg rounded-xl">
              {loading ? 'Entrando...' : (<>Entrar <ArrowRight className="ml-2 h-5 w-5" /></>)}
            </Button>
          </form>
        </div>
      </div>

      {/* Promo Card */}
      <div className="bg-gradient-to-br from-orange-500/20 to-amber-500/20 rounded-2xl border border-orange-500/30 p-5 text-center">
        <Star className="h-8 w-8 text-orange-400 mx-auto mb-2" />
        <h3 className="font-bold text-lg text-orange-300">Recogida GRATIS</h3>
        <p className="text-white/60 text-sm mt-1">Pasamos por tu casa a recoger tus cajas sin costo adicional en el area tri-state</p>
        <a href={`https://wa.me/${companyInfo.telefono_whatsapp}?text=${encodeURIComponent('Hola! Quiero agendar una recogida gratis')}`} target="_blank" rel="noreferrer">
          <Button className="mt-3 bg-orange-500 hover:bg-orange-600 font-bold rounded-xl w-full">
            <Phone className="mr-2 h-4 w-4" /> Llamar Ahora
          </Button>
        </a>
      </div>

      {/* Trust badges */}
      <div className="grid grid-cols-3 gap-2">
        {[
          { n: '500+', l: 'Envios' },
          { n: '100+', l: 'Clientes' },
          { n: '5', l: 'Furgones' },
        ].map((b, i) => (
          <div key={i} className="bg-white/5 rounded-xl p-3 text-center border border-white/5">
            <p className="text-xl font-black text-blue-400">{b.n}</p>
            <p className="text-xs text-white/40">{b.l}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoginForm;
